export const NEWS_RIBBON_BOX_PORTAL_ID = 'news-ribbon-box';
export const NEWS_RIBBON_BOX_PORTAL_EVENT = 'newsribbonboxready';
export const NEWS_RIBBON_KEY = 'news-ribbon';
